import { Routes } from '@angular/router';

import { NotFoundComponent } from './not-found/not-found.component';
import { ErrorComponent } from './error/error.component';
import { ForgotComponent } from './forgot/forgot.component';
import { LockscreenComponent } from './lockscreen/lockscreen.component';
import { SigninComponent } from './signin/signin.component';
import { SignupComponent } from './signup/signup.component';
import { EnterpriseSelectComponent } from './enterprise-select/enterprise-select.component';
import { OnboardingComponent } from './onboarding/onboarding.component';
import { RoleGuardService } from '@wephone-core/service/role_guard.service';
import { UserRole } from '@wephone-core/system';
import { SubscriptionComponent } from './subscription/subscription.component';

export const SessionRoutes: Routes = [
  {
    path: '',
    children: [
      {
        path: '404',
        component: NotFoundComponent
      },
      {
        path: 'error',
        component: ErrorComponent
      },
      {
        path: 'forgot',
        component: ForgotComponent
      },
      {
        path: 'lockscreen',
        component: LockscreenComponent
      },
      {
        path: 'signin',
        component: SigninComponent
      },
      {
        path: 'onboarding',
        component: OnboardingComponent,
        canActivate: [RoleGuardService],
        data: {
          expectedRoles: [UserRole.ADMIN]
        },
      },
      {
        path: 'subscription',
        component: SubscriptionComponent,
        canActivate: [RoleGuardService],
        data: {
          expectedRoles: [UserRole.ADMIN]
        },
      },
      {
        path: 'connect-as',
        component: SigninComponent
      },
      {
        path: 'signup',
        component: SignupComponent
      },
      {
        path: 'enterprise-select',
        component: EnterpriseSelectComponent
      }
    ]
  }
];
